<div class="off-canvas">
  <div class="off-canvas-sidebar" [class.active]="isOpen">
    <material-icon class="close-icon" (click)="isOpen = false">highlight_off</material-icon>
    <ng-content></ng-content>
  </div>
  <div class="off-canvas-overlay" (click)="isOpen = false"></div>
</div>
